import script from "./KnowledgeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeSection.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeSection.vue?vue&type=style&index=0&id=19d601d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d601d8"]])

export default __exports__